package pl.finn.forms.utils.form

import io.kvision.core.*
import io.kvision.form.FormType
import io.kvision.form.text.TextInput
import io.kvision.form.text.textInput
import io.kvision.form.upload.UploadInput
import io.kvision.form.upload.uploadInput
import io.kvision.html.*
import io.kvision.modal.Alert
import io.kvision.modal.Confirm
import io.kvision.pace.Pace
import io.kvision.table.*
import io.kvision.utils.px
import kotlinx.serialization.json.Json
import pl.finn.forms.tw1.DocumentTreeNode
import pl.finn.forms.tw17.Formularz
import pl.finn.forms.tw17.Tw17Model
import pl.finn.forms.utils.model.Util

class FormComponents17() {

  private var formAttachment: FormBuilder<DocumentTreeNode>? = null
  val format = Json { ignoreUnknownKeys = true }

  fun createAttachmentsTable(state: Formularz, reference: FormBuilder<DocumentTreeNode>): Div {

    return (
        Div {
          h6("Lista załączników do pisma", className = "mt-4")
          table(
            listOf("Nazwa pliku", "Opis załącznika", ""),
            setOf(TableType.HOVER, TableType.STRIPED, TableType.BORDERED, TableType.SMALL),
            responsiveType = ResponsiveType.RESPONSIVE
          ) {
            state.zalaczniki?.forEach { attachment ->
              row {
                cell {
                  verticalAlign = VerticalAlign.MIDDLE
                  b(attachment.nazwa)
                }
                cell {
                  verticalAlign = VerticalAlign.MIDDLE
                  attachment.opis?.let {
                    div(it)
                  }
                }
                cell {
                  align = Align.CENTER
                  width = 150.px
                  button("Usuń załącznik", "fas fa-trash", ButtonStyle.DANGER) {
                    size = ButtonSize.SMALL
                    onClick {
                      reference.getData()
                      state.form?.let { it1 -> Tw17Model.usunZalacznik(attachment.nazwa, it1) }
                    }
                  }
                }
              }
            }
          }
        }
        )
  }

  fun createButtonPanel(state: Formularz, reference: FormBuilder<DocumentTreeNode>): Div {

    return (
        Div(className = "form-group my-3") {
          div(className = "row") {
            div(className = "col-lg-6") {
              div(className = "row") {
                div(className = "col-sm-6 py-2") {
                  button(
                    "Zapisz dokument",
                    "far fa-save fa-3x d-block",
                    ButtonStyle.SUCCESS, className = "w-100"
                  ).onClick {
                    reference.getData()
//                    val jsonData = format.encodeToString(state.form)
//                    println(jsonData)

                    val validateResult =
                      if (!reference.validate()) "Dokument zawiera niepoprawne dane." else null
//                    Tw1Model.zapisz(validateResult)
                    state.form?.let { it1 -> Tw17Model.zapisz(it1, validateResult) }
                  }
                }
                div(className = "col-sm-6 py-2") {
                  button("Sprawdź dokument", "fas fa-tasks fa-3x d-block", className = "w-100").onClick {
                    val isValidated = reference.validate()
//                    if (isValidated) {
//                      Alert.show(
//                        "Sprawdzenie dokumentu",
//                        "Dokument jest poprawny.<br/>Wszystkie pola wypełnione są prawidłowo.",
//                        rich = true
//                      )
//                    } else {
//                      Alert.show(
//                        "Sprawdzenie dokumentu",
//                        "Dokument zawiera niepoprawne dane.<br/>Należy poprawić pola oznaczone na czerwono.",
//                        rich = true
//                      )
//                    }
                    reference.getData()
                    state.form?.let { it1 -> Tw17Model.sprawdz(it1) }

                  }
                }
              }
            }
            div(className = "col-lg-6") {
              div(className = "row") {
                div(className = "col-sm-6 py-2") {
                  button("Podgląd dokumentu", "fas fa-eye fa-3x d-block", className = "w-100").onClick {
                    reference.getData()
                    state.form?.let { it1 -> Tw17Model.podglad(it1, this) }
                  }
                }
                div(className = "col-sm-6 py-2") {
                  button(
                    "Anuluj",
                    "fas fa-times fa-3x d-block",
                    ButtonStyle.SECONDARY, className = "w-100"
                  ).onClick {
                    Confirm.show(
                      "Potwierdzenie",
                      "Czy anulować edycję formularza i powrócić do poprzedniej strony?",
                      yesTitle = "Tak",
                      noTitle = "Nie"
                    ) {
                      Tw17Model.anuluj()
                    }
                  }
                }
              }
            }
          }
        }
        )
  }

  fun addAttachments(state: Formularz, formReference: FormBuilder<DocumentTreeNode>): Div {
    val labelContent = "Załączniki"
    var attachment = UploadInput()
    var attachmentDescription = TextInput()
    return (
        Div(className = "form-group mb-3") {
          label(labelContent, rich = true)
          extendedPanel<DocumentTreeNode>(type = FormType.INLINE) {
            formAttachment = this
            div(className = "row") {
              div(className = "col-lg-5 py-2") {
                attachment =
                  uploadInput("/") {
                    placeholder = "Wybierz plik..."
                    explorerTheme = true
                    showUpload = false
                    showCancel = false
                    showPreview = false
                    dropZoneEnabled = false
                    allowedFileExtensions = Util.rozszerzeniaZalacznikow
                  }
              }
              div(className = "col-lg-7") {
                div(className = "row") {
                  div(className = "col-sm-8 py-2") {
                    attachmentDescription =
                      textInput(value = "Opis załącznika") {
                        placeholder = "Wprowadź opis załącznika"
                        addCssClass("form-control")
                      }
                  }
                  div(className = "col-sm-4 py-2") {
                    button("Dodaj", "fas fa-upload", className = "w-100").onClick {
                      formReference.getData()
                      if (formAttachment?.validate() == false) {
                        Alert.show(
                          "Sprawdzenie załączników",
                          "Nie można dodać załącznika<br/>" +
                              "Sprawdź czy nazwa załącznika zawiera znaki inne niż litery, cyfry lub - _ . " +
                              "oraz czy został wypełniony opis załącznika",
                          rich = true
                        )
                      } else {
                        Pace.show()
                        state.form?.let { it1 ->
                          Tw17Model.dodajZalacznik(
                            attachment,
                            attachmentDescription.value,
                            it1
                          )
                        }
                        Pace.hide()
                      }
                    }
                  }
                }
              }
            }
            enableTooltip(
              TooltipOptions(
                "Nazwa pliku nie powinna zawierać spacji oraz znaków specjalnych innych niż _ . -",
                rich = true,
                placement = Placement.BOTTOM
              )
            )
          }
        })
  }

  fun createNavigationButtons(): Component {
    return (
        Div(className = "space-between justify-end mt-4") {
          id = "buttons-container"
          button("Wstecz", className = "d-none") {
            id = "previous-button"
          }
          button("Dalej") {
            id = "next-button"
          }
        }
        )
  }
}
